import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { FACEBOOK_CONFIG } from './facebook.config';
import { FacebookConfig } from './facebook.interface';

// TODO: extend that service to export actually useful fonctionality, e.g. FB
// login.
// TODO: import from TS typings for the FB SDK
@Injectable()
export class Facebook {
  isEnabled = false;

  constructor(
    @Inject(FACEBOOK_CONFIG) private config: FacebookConfig,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    if (this.config.appId && isPlatformBrowser(this.platformId)) {
      this.isEnabled = true;
    }
  }

  async login() {
    await this.loadSdk();

    await new Promise((resolve, reject) => {
      window.FB.login((response: any) => {
        if (response.authResponse) {
          resolve(response.authResponse);
        } else {
          reject();
        }
      });
    });

    // TODO
  }

  private loadSdk(): Promise<void> {
    return new Promise((resolve, reject) => {
      window.fbAsyncInit = () => {
        window.FB.init({
          appId: this.config.appId,
          autoLogAppEvents: true,
          xfbml: false,
          cookie: false,
          status: true,
          version: 'v3.2',
        });
        resolve();
      };
      if (document.getElementById('external-fb-sdk')) {
        return;
      }
      const e = document.createElement('script');
      e.src = 'https://connect.facebook.net/en_US/sdk.js';
      e.id = 'external-fb-sdk';
      e.onerror = reject;
      const s = document.getElementsByTagName('script')[0];
      (s.parentNode as Node).insertBefore(e, s);
    });
  }
}
